module.exports = __webpack_public_path__ + "static/media/iadvize-white-logo.7864eee3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/iadvize-white-logo.svg
// module id = 1156
// module chunks = 0